export type BasketballPlayerId = 1 | 2 | 3 | 4 | 5;
export const basketballPlayerIdNumbers: BasketballPlayerId[] = [1, 2, 3, 4, 5];
export type BasketballPlayerLabelType = "NUM";
